<mat-sidenav-container
    (backdropClick)="isMobile ? toggleIsMenuOpened(false) : toggleExpanded(false)"
    [autosize]="true"
    class="container"
>
    <mat-sidenav
        [class.expanded]="isTablet && expanded"
        [class.shrunk]="isTablet && !expanded"
        [disableClose]="isTablet || isComputer"
        [mode]="isMobile || (isTablet && expanded) ? 'over' : 'side'"
        [opened]="isMobile ? isMenuOpen : true"
        class="sidenav-container bg-gradient-1"
    >
        <div class="sidenav">
            <div
                id="header"
                [class.bg-gradient-1]="(currentRoute$ | async) !== ROOT_ROUTE"
            >
                <a routerLink="/">
                    <img
                        alt="workroads-logo"
                        draggable="false"
                        id="header-logo"
                        src="assets/workroads-side-menu-logo.svg"
                        style="height: 27px"
                    />
                </a>
                <button
                    (click)="toggleExpanded(true)"
                    *ngIf="isTablet && !expanded"
                    id="header-menu-button"
                    mat-icon-button
                >
                    <mat-icon>menu</mat-icon>
                </button>
            </div>
            <div class="sidenav-content">
                <app-side-menu-content
                    [collapsedMode]="isTablet && !expanded"
                    [current]="currentRoute$ | async"
                    (navigate)="onNavigation()"
                ></app-side-menu-content>
            </div>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <app-toolbar
            [opened]="isMenuOpen"
            (toggleOpened)="toggleIsMenuOpened($event)"
        ></app-toolbar>
        <div id="container-content" (scroll)="onScroll($event)">
            <ng-content select="[content]"></ng-content>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
